<template>
    <BaseLayout>
        <div class="container py-5">
            <div class="col-lg-5 col-md-7 mx-auto">
                <div class="shadow rounded-4 p-lg-5 p-3">
                    <div class="text-center mb-4">
                        <h1 class="ff-dsb fs-36 text-primary">Reset Password</h1>
                        <p class="fs-20">Enter your new strong password.</p>
                    </div>
                    <form @submit.prevent="submit" class="vstack gap-4">
                        <div v-if="honeypot.enabled" :name="`${honeypot.nameFieldName}_wrap`" style="display:none;">
                            <input type="text" v-model="resetPasswordForm.nameFieldName" :name="honeypot.nameFieldName" />
                            <input type="text" v-model="resetPasswordForm.validFromFieldName" :name="honeypot.validFromFieldName" />
                        </div>
                        <div>
                            <label for="inputEmail" class="form-label">Email</label>
                            <input id="inputEmail" type="email" inputmode="email" v-model="resetPasswordForm.email" class="form-control" :class="errors.email ? 'is-invalid':''" placeholder="mail@example.com" value="" required autofocus>
                            <div v-if="errors.email" class="invalid-feedback">
                                {{ errors.email }}
                            </div>
                        </div>
                        <div>
                            <label for="inputPassword" class="form-label">Password <sup class="text-danger">*</sup></label>
                            <div class="input-group">
                                <input :type="showPassword ? 'text':'password'" v-model="resetPasswordForm.password" class="form-control" :class="errors.password ? 'is-invalid':''" id="inputPassword" placeholder="enter password" autocomplete="new-password">
                                <button type="button" class="input-group-text rounded-end" @click="showPassword = !showPassword">
                                    <i class="fas fa-sm" :class="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                                </button>
                                <div v-if="errors.password" class="invalid-feedback">
                                    {{ errors.password }}
                                </div>
                            </div>
                        </div>
                        <div>
                            <label for="inputPasswordConfirm" class="form-label">Confirm Password <sup class="text-danger">*</sup></label>
                            <input :type="showPassword ? 'text':'password'" v-model="resetPasswordForm.password_confirmation" class="form-control" :class="errors.password_confirmation ? 'is-invalid':''" id="inputPasswordConfirm" placeholder="enter password" autocomplete="new-password-confirm">
                            <div v-if="errors.password_confirmation" class="invalid-feedback">
                                {{ errors.password_confirmation }}
                            </div>
                        </div>

                        <div class="text-center">
                            <button class="btn btn-gradient-primary fs-15 px-5 py-3 rounded-4" type="submit" :disabled="resetPasswordForm.processing">
                                Set New Password <i v-if="resetPasswordForm.processing" class="fad fa-spinner-third fa-spin"></i>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </BaseLayout>
</template>

<script setup>
import { useReCaptcha } from 'vue-recaptcha-v3';
import { useForm  } from '@inertiajs/vue3';
import BaseLayout from '../../../../../../../resources/js/front/Layouts/BaseLayout.vue';
import { ref } from 'vue';


const props = defineProps({ errors : Object, token: String, email: String, honeypot: Object })
const { executeRecaptcha, recaptchaLoaded } = useReCaptcha()
const showPassword = ref(false);

const resetPasswordForm = useForm({
    email: props.email ?? null,
    token: props.token ?? null,
    password: null,
    password_confirmation: null,
    nameFieldName: '',
    validFromFieldName: props.honeypot.encryptedValidFrom,
    g_recaptcha_response: null,
})

async function submit() {
    await recaptchaLoaded()
    resetPasswordForm.g_recaptcha_response = await executeRecaptcha('reset')
    resetPasswordForm.post(route('user.password.update'))
}
</script>